import SportIcons from './_sport-icons.js'
import BaseEventCard from './_base-event-card.js'
import FlexPane from './_flex-pane.js'
import Image from './_image.js'
import Text from './_text.js'
import DateTime from './_date-time.js'
import AbsolutePane from './_absolute-pane.js'
import MatchAccaSelectionItem from './_match-acca-selection-item.js'
import SelectionButton from './_selection-button.js'

export default {
  name: 'PrebuiltBet',
  values: {
    showBackgroundSportImage: true,
    showCardHeader: true,
    sportIcons: {
      configSet: SportIcons,
      configValues: {},
    },
    genericEventCard: {
      configSet: BaseEventCard,
      configValues: {
        container: {
          createStackingContext: true,
          style: {
            padding: '8px',
            overflow: 'hidden',
            minHeight: '200px',
            height: 'auto',
            justifyContent: 'space-between',
            _mobile_width: '100%',
          },
        },
        clickableArea: {
          style: {
            base: {
              justifyContent: 'start',
              flexGrow: 0,
            },
          },
        },
      },
    },
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
      },
    },
    matchAccaIcon: {
      configSet: Image,
      configValues: {
        style: {
          flexGrow: 0,
          width: '12px',
          height: '16px',
        },
      },
    },
    headerTextContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          flexWrap: 'wrap',
        },
      },
    },
    eventName: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    timeAndTypeContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexWrap: 'wrap',
        },
      },
    },
    startTimeFormat: {
      configSet: DateTime,
      configValues: {
        showTodayAndTomorrowLabels: true,
      },
    },
    startTime: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    typeName: {
      configSet: Text,
      configValues: {},
    },
    matchAccaSelectionsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '8px 0',
        },
      },
    },
    genericBackgroundImageContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          width: '106px',
          height: '91px',
          top: '8px',
          right: '8px',
          overflow: 'hidden',
        },
      },
    },
    genericBackgroundSportImage: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '120px',
          minHeight: '120px',
          alignSelf: 'flex-end',
        },
      },
    },
    matchAccaSelectionItem: {
      configSet: MatchAccaSelectionItem,
      configValues: {},
    },
    selectionContentContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'flex-end',
          flexGrow: 0,
        },
      },
    },
    selectionButton: {
      configSet: SelectionButton,
      configValues: {
        view: {
          nameDisplay: 'hide',
          _mobile_nameDisplay: 'hide',
          handicapDisplay: false,
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
